import { Component } from '@angular/core';
import {DictionaryComponent} from '../../../shared/dictionary/dictionary.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UntypedFormBuilder} from '@angular/forms';
import {PracticeStateNoteType} from '../../../../../shared/models/PracticeStateNoteType';
import {PracticeStateNoteTypeService} from '../../../../services/practice-state-note-type.service';

@Component({
  selector: 'app-practice-state-note-types',
  templateUrl: './practice-state-note-types.component.html',
  styleUrls: ['./practice-state-note-types.component.css']
})
export class PracticeStateNoteTypesComponent extends DictionaryComponent<PracticeStateNoteType> {

  constructor(
    modalService: NgbModal,
    fb: UntypedFormBuilder,
    service: PracticeStateNoteTypeService
  ) {
    super(modalService, fb, service);
  }

}
